import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles( () => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        margin: '0px auto',
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '20px',
    },
    centerTitle: {
        textAlign: 'center',
        backgroundColor:'gainsboro',
    },   
}));
